import * as React from "react";
import {CSSProperties} from "react";
import {FormGroupProps} from "../../common/props/FormGroupProps";
import {option} from "ts-option";
import Checkbox from "../../../hiberUiKit/src/atoms/Checkbox/Checkbox";
import FormGroup from "../../../hiberUiKit/src/molecules/FormGroup/FormGroup";

interface ComponentProps {
	/**
	 * Custom styles for whole component.
	 */
	style?: CSSProperties,
	disabled?: boolean;
}

type Props = ComponentProps & FormGroupProps<boolean>

/**
 * Checkbox form group.
 */
export default class CheckboxFormGroup extends React.PureComponent<Props> {
	render() {
		return (
			<FormGroup error={this.props.field.firstError().orNull} >
				<Checkbox label={this.props.label}
						  onChange={value => this.onChange(value)}
						  checked={this.props.field.getOptionalValue().getOrElse(false)}
						  disabled={this.props.disabled}
						  styles={{color: "#112363", ...this.props.style}}/>
			</FormGroup>
		);
	}

	onChange(value: boolean) {
		this.props.onChange(this.props.field.updateValue(option(value)));
	}
}